import LoadingPacman from "../layout/LoadingPacman";
import { Modal, Button, ModalProps } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { ReactElement } from "react";

export interface ISimpleModal {
    showModal?: boolean;
    entityName: string;
    loading?: boolean;
    buttonConfirmationLabel?: string;
    disableConfirmation?: boolean;
    buttonConfirmationAction?(): void;
    FooterLeftComponent?: ReactElement;
    headerRightComponent?: ReactElement;
    handleClose: () => void;
    leftButtons?: {
        label: string;
        onClick(): void;
        variant?: "secondary" | "primary";
        type?: "button" | "submit" | "reset";
    }[];
    entity?: { id: number; name: string; comment: string } | null;
    modalProps?: ModalProps;
    headerProps?: any;
    isSubModal?: boolean;
    bodyProps?: any;
    footerProps?: any;
    hasFooter?: boolean;
    children?: ReactElement;
    formId: string;
}

const SimpleModal = (props: ISimpleModal) => {
    const {
        showModal = false,
        loading = false,
        handleClose = () => {},
        buttonConfirmationAction,
        disableConfirmation,
        entityName = "",
        hasFooter = true,
        leftButtons,
        FooterLeftComponent,
        headerRightComponent,
        buttonConfirmationLabel,
        modalProps,
        formId = "myForm",
        headerProps,
        bodyProps,
        footerProps,
        isSubModal = false,
        children = <></>,
    } = props;
    return (
        <>
            <Modal
                centered
                show={showModal}
                onHide={handleClose}
                backdropClassName={
                    isSubModal ? "simpleEntityGrid-backdrop-subModal" : "simpleEntityGrid-backdrop"
                }
                dialogClassName="simpleEntityGrid-modal"
                size={modalProps?.size || "lg"}
                {...modalProps}
            >
                <LoadingPacman loading={loading} />
                <Modal.Header closeButton {...headerProps} className="modal-header">
                    <Modal.Title
                        style={{ textOverflow: "ellipsis", overflow: "hidden", color: "white" }}
                    >
                        {entityName}
                    </Modal.Title>
                    {headerRightComponent && (
                        <div className="flex-grow-1 text-white">{headerRightComponent}</div>
                    )}
                </Modal.Header>
                <Modal.Body {...bodyProps}>{children}</Modal.Body>
                {hasFooter && (
                    <Modal.Footer {...footerProps}>
                        {leftButtons && (
                            <div style={{ marginRight: "auto" }}>
                                {leftButtons?.map((leftButton, index) => (
                                    <Button
                                        key={index}
                                        variant={leftButton.variant || "secondary"}
                                        onClick={leftButton.onClick}
                                        type={leftButton.type || "button"}
                                    >
                                        <FormattedMessage
                                            id={`common.action.${leftButton.label}`}
                                        />
                                    </Button>
                                ))}
                            </div>
                        )}
                        {FooterLeftComponent && (
                            <div className="flex-grow-1">{FooterLeftComponent}</div>
                        )}
                        <Button
                            variant="primary"
                            id={`submitButton_${formId}`}
                            form={formId}
                            onClick={buttonConfirmationAction}
                            disabled={loading || disableConfirmation}
                            type={buttonConfirmationAction ? "button" : "submit"}
                            className="me-4"
                        >
                            {buttonConfirmationLabel ? (
                                <>{buttonConfirmationLabel}</>
                            ) : (
                                <FormattedMessage id="common.action.save" />
                            )}
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        </>
    );
};

SimpleModal.propTypes = {};

export default SimpleModal;
